import Lenis from 'lenis';
import { initAreaReveal } from './area-reveal.js';
import { siteMotion } from './site-motion.js';
import { initWorksNavigation } from './works-navigation.js';

const root = document.querySelector('.works-collection');
const lenis = new Lenis({ autoRaf: true, smoothWheel: false, respectReducedMotion: false });
const destroyNavigation = initWorksNavigation(root, lenis);
const destroyReveal = initAreaReveal(root.querySelectorAll('.service-title, .service-intro-copy, .work-entry-media, .work-entry-copy, .work-entry-shots > figure'), {
  root: null, reducedMotion: siteMotion,
});
window.addEventListener('pagehide', destroyReveal, { once: true });
if (import.meta.hot) import.meta.hot.dispose(() => {
  window.removeEventListener('pagehide', destroyReveal);
  destroyNavigation();
  destroyReveal();
  lenis.destroy();
});
